import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/info-submit',
    name: 'InfoSubmit',
    component: () => import('../views/InfoSubmit.vue')
  },
  {
    path: '/confirm-submit',
    name: 'ConfirmSubmit',
    component: () => import('../views/ConfirmSubmit.vue')
  },
  {
    path: '/signature',
    name: 'Signature',
    component: () => import('../views/Signature.vue')
  },
  {
    path: '/success',
    name: 'SuccessPage',
    component: () => import('../views/SuccessPage.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 不需要登录的页面
  const whiteList = ['/']
  
  // 判断是否需要登录
  if (whiteList.includes(to.path)) {
    next()
  } else {
    // 检查是否已登录
    const token = sessionStorage.getItem('token')
    if (token) {
      next()
    } else {
      // 未登录，跳转到登录页
      next('/')
    }
  }
})

export default router